import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UserDto } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { debounceTime, tap, switchMap, finalize } from 'rxjs';
import { ShowApitokenDialogComponent } from '../show-apitoken-dialog/show-apitoken-dialog.component';

@Component({
    selector: 'add-apitoken-dialog',
    templateUrl: './add-apitoken-dialog.component.html',
    styleUrls: ['./add-apitoken-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddApitokenDialogComponent implements OnInit {

  userForm!: UntypedFormGroup;
  users!: UserDto[];
  selectedUserName:string = "";
  selectedUserId:string = "";
  selectedUserEmail:string = "";
  isLoading = false;
  isUserSelected = false;
  currentPage = 1;
  pageSize = 10000;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddApitokenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // flag: Token für alle oder nur f. eigenen User erstellen
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if(this.data){
      this.createUserForm();
      this.searchTenantUsers();
    } 
    // else {
    //   this.addForOwn()
    // }
  }

  createUserForm() {
    this.userForm = this.formBuilder.group({
      tokenUser:[null, [Validators.required]],
    });

  }

  searchTenantUsers() {
    console.log("---------> add-apitoken-dialog: search in tenant db")
    let db:string = this.tenantService.currentTenantName;
    let searchText="";
    this.tenantService.loadTenantUsers(db, searchText, this.currentPage, this.pageSize).subscribe({
      next: (userDto: UserDto[]) => {
        this.users = userDto.sort((a, b) => (a.last_Name > b.last_Name) ? 1 : ((b.last_Name > a.last_Name) ? -1 : 0));

        if(this.users.length > 0){
        }
        else{
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NORETRIEVEDUSERS"]} `);
        }        
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERSERROR"]}`)
    });

    this.userForm.get('tokenUser')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.tenantService.loadTenantUsers(db, value, this.currentPage, this.pageSize)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDto: UserDto[]) => {
          this.users = userDto;
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
  }

  displayFn(user: any) {
    console.log("displayFn: user = ", user)
    if (user) { return user.userName; }
  }

  optionSelected(event: any) {
    console.log("event:", event);
    //console.log("userId:", event.option.value.id);
    this.selectedUserName = (event.option.value.emailConfirmed)?event.option.value.userName:event.option.value.email;
    this.selectedUserId = event.option.value.id;
    this.selectedUserEmail = event.option.value.email;
    // this.projectGroupRoleUser.tenantId = event.option.tenantId;
    this.isUserSelected = true;
  }

  cancel() {
    this._dialogRef.close();
  }

  add() {
    if (this.userForm.valid) {
      let userData = {userDto: this.userForm.value};
      userData.userDto.userId = this.selectedUserId;
      userData.userDto.userEmail = this.selectedUserEmail;
      this._dialogRef.close(userData);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }
}
